<template>
    <v-form @submit.prevent="atualizarLicitacao">
        <div class="az-form-content">
            <v-container fluid grid-list-xl>
                <dados-gerais @atualizar="atualizarLicitacao" :acao="acao" v-model="licitacaoAtualizacao" :exibirAno="exibirAno"></dados-gerais>
                <div class="az-actions-form">
                  <div class="align-left"></div>
                    <div class="align-right" v-if="editando && isEditavel">
                      <a class="action-primary" @click="atualizarLicitacao">Salvar</a>
                  </div>
                </div>
            </v-container>
        </div>
    </v-form>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import DadosGerais from '../commons/DadosGerais.vue'
    import {actionTypes} from '@/commons/constants'
    import _ from "lodash";
    import store from "@/commons/store";
    import validadorDatas
      from "@/views/credenciamento/detalhe-credenciamento/orgao/credenciamento-atualizacao-validador-datas";

    export default {
        name: 'CredenciamentoAtualizacaoDadosGerais',
        components: {DadosGerais},
        data() {
            return {
                editando: false,
                licitacaoAtualizacao: {}
            }
        },
        computed: {
            isEditavel(){
              return !this.licitacao.publicado
            },
            acao() {
                if (this.editando) {
                    return 'editando'
                }
                return 'visualizando'
            },
            exibirAno() {
                return this.parametros.propriedadesLicitacao.exibirAno
            },
            exibirDataHoraAberturaCredenciamento() {
                const propriedades = this.parametros && this.parametros.propriedadesLicitacao
                return !!(propriedades && propriedades.exibirDataHoraAberturaCredenciamento)
            },
            ...mapState(['licitacao','parametros'])
        },
        async mounted() {
            this.editando = this.deveEditar()
            await this.buscarLicitacao(this.$route.params.id)
            await this.atribuirLicitacao()
        },
        methods: {
            async atribuirLicitacao(){
              this.licitacaoAtualizacao = _.cloneDeep(this.licitacao)
            },
            deveEditar(){
              let isEdicao = this.$route.query.edicao
              return !!(isEdicao && store.state.perfilCredenciamentoEdicao.value)
            },
            async atualizarLicitacao() {
                this.validarAmparoLegal()
                const validarBeneficioRegionalLocal = this.validarBeneficioRegional()
                if(!validarBeneficioRegionalLocal){
                  this.mostrarNotificacaoErro('Informe os municípios.')
                  return
                }
                const validado = await this.$validator._base.validateAll()
                if (!validado) {
                    this.mostrarNotificacaoErro('Preencha corretamente os campos obrigatórios.')
                    return
                }

                const datasValidadas = await this.validarDatas()

                if (!datasValidadas.valido) {
                  this.mostrarNotificacaoErro(datasValidadas.mensagem)
                  return
                }

                this.setMensagemLoading('Atualizando o credenciamento...')
                await this.$store.dispatch(actionTypes.ATUALIZAR_LICITACAO, {
                    licitacaoId: this.licitacaoAtualizacao.id,
                    licitacao: this.licitacaoAtualizacao
                })
                this.buscarLicitacao(this.licitacao.id)
                this.mostrarNotificacaoSucessoDefault()
            },
            validarAmparoLegal(){
              if(this.licitacaoAtualizacao.amparoLegal && !this.licitacaoAtualizacao.amparoLegal.id){
                this.licitacaoAtualizacao.amparoLegal = null
              } else if(this.licitacaoAtualizacao.amparoLegal){
                this.licitacaoAtualizacao.idAmparoLegal = this.licitacaoAtualizacao.amparoLegal.id
                this.licitacaoAtualizacao.amparoLegal = {
                    id: this.licitacaoAtualizacao.amparoLegal.id
                }
              }
            },
            validarBeneficioRegional(){
              if(this.licitacaoAtualizacao.beneficiosRegionais.length === 0 && this.licitacaoAtualizacao.beneficioRegional){
                 return false
              }
              return true
            },
            validarDatas() {
              return validadorDatas.validar(this.licitacaoAtualizacao, this.exibirDataHoraAberturaCredenciamento)
            },
            ...mapActions([actionTypes.BUSCAR_LICITACAO, actionTypes.BUSCAR_QTD_PROPOSTAS_POR_LICITACAO])
        },
        watch: {
          'licitacao.publicado': {
            async handler() {
              await this.atribuirLicitacao()
            }
          }
        }
    }
</script>
